export const audioRadius = 1100